<template>
  <div id="main">
    <div class="main-content">
      <div class="certificate-box" v-if="certificateList.total>0">
        <template v-for="(item,index) in certificateList.data">
          <div class="items" :key="item.id" v-if="index<10">
            <div class="insets">
              <img :src="item.path" />
            </div>
            <div class="explain">
              <div class="explain-name">{{ item.name }}</div>
              <div class="explain-details">
                <div class="name">
                  <div class="name-icon"></div>
                  <div class="name-text">培训名称: {{ item.org_name }}&#8195;( 第{{item.num}}期 ) </div>
                </div>
                <div class="time">
                  <span class="time-icon"></span>
                  <span class="time-text">颁发时间: {{ item.created_at.substring(0,10) }}</span>
                </div>

              </div>
              <div class="line"></div>
            </div>
            <div class="operation">
              <div class="download">
                <div class="download-icon"></div>
                <div class="download-text" @click="downFile(item.name,item.id)">下载</div>
              </div>
              <div class="check">
                <div class="check-icon"></div>
                <div class="check-text" @click="checkDetails(item.path)">查看</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-else class="noData-box">
        <img src="@/assets/empty.png" alt="">
        <div class="text">暂无相关内容</div>
      </div>
    </div>

    <div class="other">
      <div class="pages" v-if="certificateList.total>0">
        <a-pagination :defaultPageSize="10" @change="onChange" :locale="zhCN" :default-current="1" :total="certificateList.total" :current="currentPage" />
      </div>

      <div class="details-box" v-if="detailsDialog">
        <div class="details-content">
          <img :src="lookImgSrc">
          <div class="icon-close" @click="closeDetails"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import services from "../../../config/services.js"
import axios from "axios";
export default {
  data () {
    return {

      certificateList: [],
      num: 1,
      zhCN,
      tabs: 0,
      courseType: 1,
      currentPage: 1,
      detailsDialog: false,
      imgUrl: "",
      lookImgSrc: "",
      showNoBox: false,
    };

  },
  created () {
    this.getCertificateList(this.currentPage)
  },
  methods: {
    onChange (pageNumber) {
      this.currentPage = pageNumber;
      this.getCertificateList(this.currentPage)
      document.querySelector("#main").scrollTo(0, 0)
    },
    // 查看图片
    checkDetails (path) {
      let that = this
      if (path) {
        this.detailsDialog = true
        this.lookImgSrc = path
      } else {
        that.$message.error('资源不存在');
      }

    },
    // 关闭查看图片窗口
    closeDetails () {
      this.detailsDialog = false
      this.lookImgSrc = ""
    },
    // 下载文件
    downFile (name, id) {
      let that = this
      axios.get(`${services.APPS_SERVIER}/api/user/cert/down/${id}`, { responseType: 'blob' }).then(function (res) {
        if (res.data) {
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement("a");
          document.body.appendChild(a);
          let fileName = res.headers['content-type'].split("/")[1]
          a.href = url;
          a.download = name + '.' + fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          that.$message.error('资源不存在');
        }

      })
    },
    getCertificateList (pageNum) {
      let that = this
      services.getUserCert({page: pageNum}).then(res => {
        if (res.code == '0000') {
          that.certificateList = res.data
          if (res.data.data.length == 0) {
            that.showNoBox = true
          }
        } else {
          that.$message.error('请求出错');
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.noData-box {
  text-align: center;
  padding-top: 20px;
}
.pages {
  margin-top: 20px;
  margin-bottom: unset;
}
#main {
  padding: 20px;
  height: 770px;
  overflow-y: scroll;
  width: 100%;
}
.certificate-box .items {
  width: 100%;
  margin-bottom: 8px;
  display: flex;
  /* align-items: center; */
  padding: 15px 15px;
}
.certificate-box .items:hover {
  background: #f6f6f6;
  border-radius: 2px;
}

.certificate-box .insets {
  width: 160px;
  height: 90px;
  align-self: center;
}
.certificate-box .insets img {
  width: 100%;
  height: 100%;
}
.certificate-box .explain {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  flex: 1;
  position: relative;
  align-self: normal;
}
.certificate-box .explain .line {
  width: 1px;
  height: 88px;
  background: linear-gradient(0deg, #f8f8f8 0%, #e9eefa 53%, #f8f8f8 100%);
  position: absolute;
  right: 27px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.certificate-box .explain .explain-details {
  display: flex;
  margin-top: 16px;
  justify-content: space-between;
}
.certificate-box .explain .explain-name {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #4c4c4c;
  width: 545px;
  margin-top: 5px;
}
.certificate-box .explain .explain-details .time {
  display: flex;
  /* align-items: center; */
  margin-right: 72px;
}
.certificate-box .explain .explain-details .time .time-icon {
  width: 17px;
  height: 17px;
  background: url('../../../assets/site/myCertificate/icon-time.png');
  margin: 2px 7px 0 0;
}
.certificate-box .explain .explain-details .time .time-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #a0a4aa;
}
.certificate-box .explain .explain-details .name {
  display: flex;
  position: relative;
}
.certificate-box .explain .explain-details .name .name-icon {
  width: 17px;
  height: 17px;
  background: url('../../../assets/site/myCertificate/icon-name.png');
  margin-right: 7px;
  margin-top: 2px;
  position: absolute;
  left: 0;
  top: 0;
}
.certificate-box .explain .explain-details .name .name-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #a0a4aa;
  width: 325px;
  margin-left: 25px;
}
.certificate-box .operation {
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  margin-right: 20px;
  padding-top: 12px;
}
.certificate-box .operation .download {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.certificate-box .operation .download-icon {
  width: 10px;
  height: 12px;

  background: url('../../../assets/site/myCertificate/icon-download.png');
}
.certificate-box .operation .download-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #2462f5;
  margin-left: 10px;
}
.certificate-box .operation .check {
  display: flex;
  align-items: center;
  margin-top: 11px;
}
.certificate-box .operation .check-icon {
  width: 14px;
  height: 10px;
  background: url('../../../assets/site/myCertificate/icon-check.png');
}
.certificate-box .operation .check-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #2462f5;
  margin-left: 8px;
  cursor: pointer;
}
.details-box {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.details-box .details-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.details-box .details-content img {
  max-width: 100% !important;
  max-height: 100% !important;
}

.details-box .details-content .icon-close {
  display: inline-block;
  background: url('../../../assets/site/myCertificate/icon-close.png') center
    center;
  width: 34px;
  height: 34px;
  position: absolute;
  cursor: pointer;
  right: -42px;
  top: -42px;
}

.noData-box {
  width: 100%;
  text-align: center;
  padding-top: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    width: 240px;
    height: auto;
    margin: 0 auto 30px;
  }
  .text {
    color: #76797e;
    font-size: 14px;
  }
}
</style>
